<router-outlet></router-outlet>
<app-update-notice></app-update-notice>
